// extracted by mini-css-extract-plugin
export default {"root":"Button_root__U1Ijh","filled":"Button_filled__yFv-+","outlined":"Button_outlined__vIjCU","ghost":"Button_ghost__ASzPk","fullWidth":"Button_fullWidth__ONHje"};